/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */

import $__ace_builds_src_noconflict_ace from 'ace-builds/src-noconflict/ace';
import $__ace_builds_src_noconflict_mode_javascript from "ace-builds/src-noconflict/mode-javascript";

var Ace = $__ace_builds_src_noconflict_ace;

// load the javascript mode which contains cstyle helpers
$__ace_builds_src_noconflict_mode_javascript

var oop = Ace.require("ace/lib/oop");
var DocCommentHighlightRules = Ace.require("ace/mode/doc_comment_highlight_rules").DocCommentHighlightRules;
var TextHighlightRules = Ace.require("ace/mode/text_highlight_rules").TextHighlightRules;

var ElectricImpHighlightRules = function(options) {
    var keywordMapper = this.createKeywordMapper({
        "variable.language":
            "array|blob|getroottable|date|this|time|math|clock|"+       // Squirrel
            "agent|device|server|imp|hardware|nv|http|",                // electric imp
        "keyword.language":
            "assert|bindenv|castf2i|casti2f|swap2|swap4|swapfloat|"+    // Squirrel
            "regexp|regexp2|format|lstrip|rstrip|split|strip",          // Squirrel/Strings
        "keyword":
            "base|break|case|catch|clone|const|continue|default|delete|" +
            "do|else|extends|for|foreach|if|in|resume|return|static|switch" +
            "throw|try|typeof|while|yield|constructor|instanceof|",
        "storage.container":
            "const|local|function|class|enum",
        "constant.language":
            // langauge / math
            "null|RAND_MAX|PI|"+
            // pin.configure
            "DIGITAL_IN|DIGITAL_IN_PULLUP|DIGITAL_IN_PULLDOWN|DIGITAL_IN_WAKEUP|"+
            "DIGITAL_OUT|DIGITAL_OUT_OD|DIGITAL_OUT_OD_PULLUP|ANALOG_IN|"+
            "ANALOG_OUT|PWM_OUT|PWM_OUT_STEPS|PULSE_COUNTER|" +
            "PTPG_OUT_ACTIVE_HIGH|PTPG_OUT_ACTIVE_LOW|"+
            // hardware.configure
            "SPI_257|SPI_189|UART_1289|UART_57|UART_12|I2C_12|I2C_89|"+
            // spi.configure
            "SIMPLEX_TX|SIMPLEX_RXCLOCK_IDLE_HIGH|CLOCK_IDLE_LOW|CLOCK_2ND_EDGE|"+
            "LSB_FIRST|MSB_FIRST|NO_SCLK|"+
            // uart.configure
            "NO_TX|NO_RX|NO_CTSRTS|CALLBACK_WITH_FLAGS|PARITY_NONE|PARITY_EVEN|PARITY_ODD|"+
            // i2c.configure
            "CLOCK_SPEED_10_KHZ|CLOCK_SPEED_50_KHZ|CLOCK_SPEED_100_KHZ|CLOCK_SPEED_400_KHZ|"+
            // sampler.confiugure
            "NORMALISE|A_LAW_COMPRESS|"+
            // fixedfrequencydac
            "A_LAW_DECOMPRESS|AUDIO|SYNC|"+
            // imp.environment
            "ENVIRONMENT_CARD|ENVIRONMENT_MODULE|ENVIRONMENT_AGENT|"+
            // Wake reasons
            "WAKEREASON_POWER_ON|WAKEREASON_TIMER|WAKEREASON_SW_RESET|WAKEREASON_PIN1|"+
            "WAKEREASON_PIN|WAKEREASON_NEW_SQUIRREL|WAKEREASON_SQUIRREL_ERROR|"+
            "WAKEREASON_NEW_FIRMWARE|WAKEREASON_SNOOZE|WAKEREASON_HW_RESET|WAKEREASON_BLINKUP|"+
            // server.onshutdown handler
            "SHUTDOWN_NEWSQUIRREL|SHUTDOWN_NEWFIRMWARE|SHUTDOWN_OTHER|"+
            // timeout policy
            "WAIT_TIL_SENT|WAIT_FOR_ACK|SUSPEND_ON_ERROR|RETURN_ON_ERROR|"+
            // server.factoryblinkup
            "BLINKUP_FAST|BLINKUP_ACTIVEHIGH|"+
            // server.connect callback
            "SERVER_CONNECTED|NO_WIFI|NO_IP_ADDRESS|NO_SERVER|NOT_RESOLVED|NOT_CONNECTED|"+
            // send error codes
            "SEND_ERROR_NOT_CONNECTED|SEND_ERROR_TIMEOUT|SEND_ERROR_DISCONNECTED|"+
            // Days of the week
            "SUNDAY|MONDAY|TUESDAY|WEDNESDAY|THURSDAY|FRIDAY|SATURDAY|"+
            // UART callback flags
            "WRITE_DONE|READ_READY|NOISE_ERROR|FRAME_ERROR|PARITY_ERROR|"+
            "OVERRUN_ERROR|LINE_IDLE|WRITE_HALF_DONE|"+
            // spiflash verification
            "SPIFLASH_POSTVERIFY|SPIFLASH_PREVERIFY|"+
            // http.request
            "NO_TIMEOUT|VALIDATE_NONE|VALIDATE_USING_SYSTEM_CA_CERTS",

        "constant.language.boolean": "true|false"
    }, "identifier");

    // keywords which can be followed by regular expressions
    var kwBeforeRe = "case|do|else|in|return|throw|try|typeof|yield";

    // From squirrel-lang.org
    var identifierRe = "[a-zA-Z_]+[a-zA-Z_0-9]*";

    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
        "u[0-9a-fA-F]{4}|" +                    // unicode
        "[0-2][0-7]{0,2}|" +                    // oct
        "3[0-6][0-7]?|" +                       // oct
        "37[0-7]?|" +                           // oct
        "[4-7][0-7]?|" +                        // oct
        ".)";

    // regexp must not have capturing parentheses. Use (?:) instead.
    // regexps are ordered -> the first match is used

    this.$rules = {
        "no_regex" : [
            DocCommentHighlightRules.getStartRule("doc-start"),
            {
                token : ["keyword.operator", "string"],
                regex : '(@)(")',
                next : "vstring"
            },
            {
                // #require "x.class.nut:1.0.0"
                token : ["keyword", "text", "entity.name"],
                regex : /(\#require)(\s+)(\"[a-zA-Z0-9_\.\:]*\")/
            }, 
            {
                token : ["keyword", "text", "text", "text", "entity.name"],
                regex: /(\#line)(\s+)(\d+)(\s+)(\"[\/a-zA-Z0-9.]*\")/
            },
            {
                token : "comment",  // single line comments
                regex : "\\/\\/|\#",
                next : "line_comment"
            }, {
                token : "comment", // multi line comment
                regex : /\/\*/,
                next : "comment"
            }, {
                token : "constant.numeric",
                regex : "'.'",
            }, {
                token : "string",
                regex : '"(?=.)',
                next  : "qqstring"
            }, {
                token : "constant.numeric", // hex
                regex : /0[xX][0-9a-fA-F]+\b/
            }, {
                token : "constant.numeric", // float
                regex : /[+-]?\d+(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/
            }, {
                // X(.y?) <- class/function
                token : ["entity.name", "text", "keyword.operator", "text", "storage.container", "text", "paren.lparen"],
                regex : "([a-zA-Z_]+[a-zA-Z_0-9\.]*)(\\s*)(<-)(\\s*)(class|function)(\\s*)({|\\()"
            }, {
                // local X = class/function
                token : ["storage.container", "text", "entity.name", "text", "keyword.operator", "text", "storage.container", "text", "paren.lparen"],
                regex : "(local)?(\\s*)([a-zA-Z_]+[a-zA-Z_0-9\.]*)(\\s*)(=)(\\s*)(class|function)(\\s*)({|\\()"
            }, {
                // class/function X
                token : ["storage.container", "text", "entity.name", "text", "paren.lparen"],
                regex : "(class|function)(\\s+)([a-zA-Z_]+[a-zA-Z_0-9\.]*)(\\s*)({|\\()"
            }, {
                token : "keyword",
                regex : "(?:" + kwBeforeRe + ")\\b",
                next : "start"
            }, {
                token : keywordMapper,
                regex : identifierRe
            }, {
                token : "keyword.operator",
                regex : /<-|!=?|\|\|?|\&\&?|<<|>>>?|\^|~|==?|<=?|>=?|<=>|\+\+|--|\+=?|-=?|\*=?|%=?|\/=?/,
                next  : "start"
            }, {
                token : "punctuation.operator",
                regex : /[?:,;.]/,
                next  : "start"
            }, {
                token : "paren.lparen",
                regex : /[\[({]/,
                next  : "start"
            }, {
                token : "paren.rparen",
                regex : /[\])}]/
            }, {
                token: "comment",
                regex: /^#!.*$/
            }
        ],
        // regular expressions are only allowed after certain tokens. This
        // makes sure we don't mix up regexps with the divison operator
        "start": [
            DocCommentHighlightRules.getStartRule("doc-start"),
            {
                token : "comment", // multi line comment
                regex : "\\/\\*",
                next : "comment_regex_allowed"
            }, {
                token : "comment",
                regex : "\\/\\/",
                next : "line_comment_regex_allowed"
            }, {
                token : "text",
                regex : "\\s+|^$",
                next : "start"
            }, {
                // immediately return to the start mode without matching
                // anything
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "regex": [
            {
                // escapes
                token: "regexp.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                // flag
                token: "string.regexp",
                regex: "/[sxngimy]*",
                next: "no_regex"
            }, {
                // invalid operators
                token : "invalid",
                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
            }, {
                // operators
                token : "constant.language.escape",
                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
            }, {
                token : "constant.language.delimiter",
                regex: /\|/
            }, {
                token: "constant.language.escape",
                regex: /\[\^?/,
                next: "regex_character_class"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp"
            }
        ],
        "regex_character_class": [
            {
                token: "regexp.charclass.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "constant.language.escape",
                regex: "]",
                next: "regex"
            }, {
                token: "constant.language.escape",
                regex: "-"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp.charachterclass"
            }
        ],
        "function_arguments": [
            {
                token: "variable.parameter",
                regex: identifierRe
            }, {
                token: "punctuation.operator",
                regex: "[, ]+"
            }, {
                token: "punctuation.operator",
                regex: "$"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "comment_regex_allowed" : [
            DocCommentHighlightRules.getTagRule(),
            {token : "comment", regex : "\\*\\/", next : "start"},
            {defaultToken : "comment", caseInsensitive: true}
        ],
        "comment" : [
            DocCommentHighlightRules.getTagRule(),
            {token : "comment", regex : "\\*\\/", next : "no_regex"},
            {defaultToken : "comment", caseInsensitive: true}
        ],
        "line_comment_regex_allowed" : [
            DocCommentHighlightRules.getTagRule(),
            {token : "comment", regex : "$|^", next : "start"},
            {defaultToken : "comment", caseInsensitive: true}
        ],
        "line_comment" : [
            DocCommentHighlightRules.getTagRule(),
            {token : "comment", regex : "$|^", next : "no_regex"},
            {defaultToken : "comment", caseInsensitive: true}
        ],
        "qqstring" : [
            {
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "string",
                regex : "\\\\$",
                next  : "qqstring"
            }, {
                token : "string",
                regex : '"|$',
                next  : "no_regex"
            }, {
                defaultToken: "string"
            }
        ],
        "vstring" : [
            { token : "string", regex : '""', next : "vstring" },
            { token : "string", regex : '"', next : "no_regex" },
            { defaultToken : "string", caseInsensitive: true }
        ]
    };


    if (!options || !options.noES6) {
        this.$rules.no_regex.unshift({
            regex: "[{}]", onMatch: function(val, state, stack) {
                this.next = val == "{" ? this.nextState : "";
                if (val == "{" && stack.length) {
                    stack.unshift("start", state);
                    return "paren";
                }
                if (val == "}" && stack.length) {
                    stack.shift();
                    this.next = stack.shift();
                    if (this.next.indexOf("string") != -1)
                        return "paren.quasi.end";
                }
                return val == "{" ? "paren.lparen" : "paren.rparen";
            },
            nextState: "start"
        }, {
            token : "string.quasi.start",
            regex : /`/,
            push  : [{
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "paren.quasi.start",
                regex : /\${/,
                push  : "start"
            }, {
                token : "string.quasi.end",
                regex : /`/,
                next  : "pop"
            }, {
                defaultToken: "string.quasi"
            }]
        });
    }

    this.embedRules(DocCommentHighlightRules, "doc-",
        [DocCommentHighlightRules.getEndRule("no_regex")]);

    this.normalizeRules();
};

oop.inherits(ElectricImpHighlightRules, TextHighlightRules);

export default ElectricImpHighlightRules ;


